import { render, staticRenderFns } from "./CoinExchangePage.vue?vue&type=template&id=c728dd4c&scoped=true&"
import script from "./CoinExchangePage.vue?vue&type=script&lang=js&"
export * from "./CoinExchangePage.vue?vue&type=script&lang=js&"
import style0 from "./CoinExchangePage.vue?vue&type=style&index=0&id=c728dd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c728dd4c",
  null
  
)

export default component.exports